module.exports = __webpack_public_path__ + "static/media/delete.c1fde021.svg";